import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { PostPaidStatus } from '@/_types/places';

type PutPostPaidParams = {
  placeId: string;
  statusPostPaid?: PostPaidStatus;
  postPaidLimit?: number;
};

const putPostPaid = async ({
  placeId,
  statusPostPaid,
  postPaidLimit,
}: PutPostPaidParams) =>
  apiClient
    .put(`/estabelecimentos/${placeId}/post-paid`, {
      statusPostPaid,
      postPaidLimit,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        `Pós-pago ${
          statusPostPaid === 'ACTIVE' ? 'ativado' : 'desativado'
        } com sucesso!`,
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível alterar o status do pós-pago.',
      ),
    );

export const usePutPostPaid = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PutPostPaidParams> = {}) => {
  return useMutation({
    mutationFn: putPostPaid,
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...options,
  });
};
